import { gql, useFragment } from "@apollo/client";

// Style
import style from "./hero.module.scss";

// Constants
import { heroBlock } from "@/constants/constants";
import { bgColorFields, imgFields } from "@/constants/gql-fields";

// Components
import BackgroundColor from "@/components/bg-color/bg-color";
import BackgroundImage from "@/components/bg-image/bg-image";

export default function Hero({ module }) {
  // Use Fragment
  const { complete, data } = useFragment({
    fragment: Hero.fragments.module,
    fragmentName: "HeroFragment",
    from: {
      __typename: module.__typename,
      id: module.id,
    },
  });

  if (!complete) {
    return;
  }

  return (
    <section data-h-align={data.hAlign} data-v-align={data.vAlign}>
      <BackgroundColor
        colorSettings={data.heroBackgroundColor?.cloneBgColorColorSettings}
      />

      <BackgroundImage
        imageSettings={data.backgroundImage?.image?.node}
        hasOverlay={data.hasOverlay}
        overlayColor={data.overlayColor}
      />

      <div
        className={`container ${style.container}`}
        style={{ minHeight: `${data.contentHeight}` }}
      >
        <div
          className={style.moduleText}
          style={{ color: `${data.textColor}` }}
          dangerouslySetInnerHTML={{ __html: data.text }}
        />
      </div>

      {/* <Image
          src={data.image.node["sourceUrl"]}
          width={500}
          height={500}
          alt={module.image["altText"] ?? ""}
        /> */}
    </section>
  );
}

Hero.fragments = {
  module: gql`
  fragment HeroFragment on ${heroBlock} {
    id
    __typename
    contentHeight
    text
    heroBackgroundColor {
      cloneBgColorColorSettings {
        ${bgColorFields}
      }
    }
    hAlign
    vAlign
    textColor
    bgType
    hasOverlay
    overlayColor
    backgroundImage {
      image {
       ${imgFields}
      }
    }
  }
`,
};
